import { render, staticRenderFns } from "./DesertMessage404.vue?vue&type=template&id=721cc65a&"
import script from "./DesertMessage404.vue?vue&type=script&lang=js&"
export * from "./DesertMessage404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports